var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('xmHeader',{attrs:{"hasPc":_vm.hasPc,"index":0}}),(_vm.hasPc)?_c('indexPc',{attrs:{"gData":_vm.PCData}}):_c('indexMobile',{attrs:{"gData":_vm.MobileData}}),_c('xmFooter',{attrs:{"hasPc":_vm.hasPc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }